export default [
  {
    isbn: "180810285-1",
    title: "Freeze Me",
    authors: ["Dennet Tomaskunas", "Zandra Drewet"],
    cover_image_url: "http://dummyimage.com/221x100.png/5fa2dd/ffffff",
    is_fiction: false,
    tags: ["Drama", "Thriller", "Action|Drama|Thriller"],
    summary:
      "Nulla suscipit ligula in lacus. Curabitur at ipsum ac tellus semper interdum. Mauris ullamcorper purus sit amet nulla.",
    pinned: false,
    active: true,
    chapters: [
      {
        id: "e818282d-825a-47d6-a58b-2a0de5fb6453",
        title: "",
        chapter_number: 1,
        sort_order: 1,
        summary: "Aliquam quis turpis eget elit sodales scelerisque.",
        notes: [
          {
            note_type: "thought",
            highlight: "Etiam vel augue. Vestibulum rutrum rutrum neque.",
            content:
              "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est. Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros. Vestibulum ac est lacinia nisi venenatis tristique. Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue.",
            id: "8a881f80-9619-4abc-bf6b-fc8dfd264f78",
            page_number: 241,
          },
          {
            note_type: "thought",
            highlight:
              "Suspendisse potenti. Nullam porttitor lacus at turpis. Donec posuere metus vitae ipsum.",
            content:
              "Nulla neque libero, convallis eget, eleifend luctus, ultricies eu, nibh. Quisque id justo sit amet sapien dignissim vestibulum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est. Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros.",
            id: "2f952b07-e212-4046-acaf-595fd5a76245",
            page_number: 191,
          },
          {
            note_type: "definition",
            highlight:
              "Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem. Integer tincidunt ante vel ipsum. Praesent blandit lacinia erat.",
            content:
              "Curabitur gravida nisi at nibh. In hac habitasse platea dictumst. Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem. Integer tincidunt ante vel ipsum. Praesent blandit lacinia erat.",
            id: "1b488e78-7ca4-479c-ba49-5d3574589431",
            page_number: 236,
          },
        ],
      },
      {
        id: "b5a6bf8c-55b7-435a-89f5-5a03685d2e66",
        title: "Hawk, galapagos",
        chapter_number: 2,
        sort_order: 2,
        summary: "Proin risus.",
        notes: [
          {
            note_type: "thought",
            highlight: "Etiam justo. Etiam pretium iaculis justo.",
            content:
              "Vivamus tortor. Duis mattis egestas metus. Aenean fermentum. Donec ut mauris eget massa tempor convallis. Nulla neque libero, convallis eget, eleifend luctus, ultricies eu, nibh.",
            id: "2dd800f4-5e10-4f9b-b4c6-05aed81db92f",
            page_number: 211,
          },
          {
            note_type: "quote",
            highlight: "Aliquam quis turpis eget elit sodales scelerisque.",
            content:
              "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin risus. Praesent lectus.",
            id: "d382025b-796c-4c14-bb25-1e656d7da3a1",
            page_number: 64,
          },
          {
            note_type: "connection",
            highlight:
              "Suspendisse accumsan tortor quis turpis. Sed ante. Vivamus tortor.",
            content:
              "Aliquam sit amet diam in magna bibendum imperdiet. Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis. Fusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl.",
            id: "450a495f-aa64-455e-9e09-732ae2da63dd",
            page_number: 3,
          },
        ],
      },
      {
        id: "86ad7752-d04d-4961-a46e-6a6e33e4e160",
        title: "Dove, rock",
        chapter_number: 3,
        sort_order: 3,
        summary:
          "Mauris ullamcorper purus sit amet nulla. Quisque arcu libero, rutrum ac, lobortis vel, dapibus at, diam.",
        notes: [
          {
            note_type: "definition",
            highlight:
              "Duis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa. Donec dapibus.",
            content:
              "Maecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat. Curabitur gravida nisi at nibh.",
            id: "de1953f0-c9d6-4155-b195-889b048ea808",
            page_number: 340,
          },
          {
            note_type: "definition",
            highlight:
              "Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat.",
            content:
              "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin interdum mauris non ligula pellentesque ultrices. Phasellus id sapien in sapien iaculis congue. Vivamus metus arcu, adipiscing molestie, hendrerit at, vulputate vitae, nisl.",
            id: "f44a38b3-7009-4b03-8ea4-fd0769828dd3",
            page_number: 47,
          },
        ],
      },
      {
        id: "6b9beb13-896c-4c1f-a1a9-ad13fbf14491",
        title: "Zebra, common",
        chapter_number: 4,
        sort_order: 4,
        summary:
          "Quisque porta volutpat erat. Quisque erat eros, viverra eget, congue eget, semper rutrum, nulla.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
            content:
              "Nulla neque libero, convallis eget, eleifend luctus, ultricies eu, nibh. Quisque id justo sit amet sapien dignissim vestibulum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est. Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros.",
            id: "5088e39e-5ada-4600-aa83-f8c3179999b4",
            page_number: 59,
          },
          {
            note_type: "thought",
            highlight: "Suspendisse accumsan tortor quis turpis. Sed ante.",
            content:
              "Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat. In congue.",
            id: "af22175e-a701-46ee-b26e-09c00e490ba4",
            page_number: 196,
          },
          {
            note_type: "quote",
            highlight:
              "Duis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa.",
            content:
              "Aliquam non mauris. Morbi non lectus. Aliquam sit amet diam in magna bibendum imperdiet. Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis. Fusce posuere felis sed lacus.",
            id: "82dfa7af-4e76-4be0-b181-803defebca74",
            page_number: 100,
          },
          {
            note_type: "concept",
            highlight:
              "Aliquam non mauris. Morbi non lectus. Aliquam sit amet diam in magna bibendum imperdiet.",
            content:
              "Vestibulum sed magna at nunc commodo placerat. Praesent blandit. Nam nulla. Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede. Morbi porttitor lorem id ligula.",
            id: "4b1de9bd-2cda-45fa-913a-165cc077886a",
            page_number: 184,
          },
          {
            note_type: "thought",
            highlight:
              "Vestibulum ac est lacinia nisi venenatis tristique. Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat.",
            content:
              "Maecenas rhoncus aliquam lacus. Morbi quis tortor id nulla ultrices aliquet. Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo.",
            id: "52c22821-2ac6-4517-b8d2-d5127353333e",
            page_number: 74,
          },
        ],
      },
    ],
  },
  {
    isbn: "979236693-8",
    title:
      "Disney Princess Collection: Jasmine's Enchanted Tales: Jasmine's Wish",
    authors: ["Lissa Drinkel"],
    cover_image_url: "http://dummyimage.com/250x100.png/cc0000/ffffff",
    is_fiction: true,
    tags: ["Documentary", "Western"],
    summary:
      "Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci.",
    pinned: false,
    active: false,
    chapters: [
      {
        id: "66688b27-37b6-4594-9581-806640434b56",
        title: "Small Indian mongoose",
        chapter_number: 1,
        sort_order: 1,
        summary: "Vivamus in felis eu sapien cursus vestibulum. Proin eu mi.",
        notes: [
          {
            note_type: "connection",
            highlight:
              "Duis ac nibh. Fusce lacus purus, aliquet at, feugiat non, pretium quis, lectus. Suspendisse potenti.",
            content:
              "Proin eu mi. Nulla ac enim. In tempor, turpis nec euismod scelerisque, quam turpis adipiscing lorem, vitae mattis nibh ligula nec sem.",
            id: "a9c61206-e5c0-40af-b768-a871e380edd8",
            page_number: 211,
          },
          {
            note_type: "quote",
            highlight: "Duis bibendum.",
            content:
              "Pellentesque ultrices mattis odio. Donec vitae nisi. Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla. Sed vel enim sit amet nunc viverra dapibus.",
            id: "1564cda4-49bd-4f04-a408-25ceb1859a72",
            page_number: 26,
          },
          {
            note_type: "concept",
            highlight: "Morbi non lectus.",
            content:
              "Donec semper sapien a libero. Nam dui. Proin leo odio, porttitor id, consequat in, consequat ut, nulla.",
            id: "78f006a9-c096-45cc-b7b7-76a0fc351d7e",
            page_number: 317,
          },
        ],
      },
      {
        id: "0a9e9519-269c-45f9-91bc-2fab43071815",
        title: "European stork",
        chapter_number: 2,
        sort_order: 2,
        summary: "Morbi porttitor lorem id ligula.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "Pellentesque viverra pede ac diam. Cras pellentesque volutpat dui.",
            content:
              "Duis consequat dui nec nisi volutpat eleifend. Donec ut dolor. Morbi vel lectus in quam fringilla rhoncus. Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id, turpis.",
            id: "eed5c349-68c5-492d-8cb3-b8d0524a95ad",
            page_number: 318,
          },
          {
            note_type: "connection",
            highlight: "Fusce consequat.",
            content:
              "Duis bibendum. Morbi non quam nec dui luctus rutrum. Nulla tellus. In sagittis dui vel nisl.",
            id: "cb42b7a1-2be9-49ec-9c92-6ff7e371db50",
            page_number: 397,
          },
          {
            note_type: "thought",
            highlight: "In sagittis dui vel nisl. Duis ac nibh.",
            content:
              "Praesent lectus. Vestibulum quam sapien, varius ut, blandit non, interdum in, ante. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis faucibus accumsan odio. Curabitur convallis.",
            id: "71322497-4d12-4f86-bae8-849091ee77fe",
            page_number: 340,
          },
          {
            note_type: "connection",
            highlight: "Morbi a ipsum. Integer a nibh.",
            content:
              "Curabitur in libero ut massa volutpat convallis. Morbi odio odio, elementum eu, interdum eu, tincidunt in, leo. Maecenas pulvinar lobortis est. Phasellus sit amet erat.",
            id: "e8a0faa1-f38b-4c4d-9b0d-31af594dd11d",
            page_number: 52,
          },
          {
            note_type: "thought",
            highlight: "Integer ac leo.",
            content:
              "Integer aliquet, massa id lobortis convallis, tortor risus dapibus augue, vel accumsan tellus nisi eu orci. Mauris lacinia sapien quis libero. Nullam sit amet turpis elementum ligula vehicula consequat. Morbi a ipsum. Integer a nibh.",
            id: "c9377cd2-2a42-4e07-bdb4-3b89bd0b1be6",
            page_number: 68,
          },
        ],
      },
      {
        id: "6371497c-dcaf-47b7-8ef1-7515481fdacc",
        title: "Red-tailed wambenger",
        chapter_number: 3,
        sort_order: 3,
        summary: "In quis justo.",
        notes: [
          {
            note_type: "concept",
            highlight:
              "Pellentesque ultrices mattis odio. Donec vitae nisi. Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla.",
            content:
              "Quisque id justo sit amet sapien dignissim vestibulum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est. Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros.",
            id: "7dfc7af2-965e-475b-8c6d-275acf145456",
            page_number: 213,
          },
          {
            note_type: "quote",
            highlight:
              "Morbi quis tortor id nulla ultrices aliquet. Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo. Pellentesque viverra pede ac diam.",
            content:
              "Mauris lacinia sapien quis libero. Nullam sit amet turpis elementum ligula vehicula consequat. Morbi a ipsum.",
            id: "9180d5cd-b0a9-4917-ad57-aa999666c44d",
            page_number: 220,
          },
        ],
      },
      {
        id: "9cb2728d-56b5-410b-b7dd-fbd4e95b6719",
        title: "Killer whale",
        chapter_number: 4,
        sort_order: 4,
        summary:
          "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue.",
        notes: [
          {
            note_type: "definition",
            highlight: "Duis bibendum.",
            content:
              "Morbi non lectus. Aliquam sit amet diam in magna bibendum imperdiet. Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis. Fusce posuere felis sed lacus.",
            id: "c88028b4-b612-4c83-be23-d9dc2d4b97fb",
            page_number: 397,
          },
          {
            note_type: "quote",
            highlight:
              "Integer tincidunt ante vel ipsum. Praesent blandit lacinia erat.",
            content:
              "Integer aliquet, massa id lobortis convallis, tortor risus dapibus augue, vel accumsan tellus nisi eu orci. Mauris lacinia sapien quis libero. Nullam sit amet turpis elementum ligula vehicula consequat. Morbi a ipsum. Integer a nibh.",
            id: "70dbafa6-c5dd-48dd-86fb-a0e6b36bb37c",
            page_number: 232,
          },
          {
            note_type: "connection",
            highlight:
              "Proin leo odio, porttitor id, consequat in, consequat ut, nulla. Sed accumsan felis.",
            content:
              "Sed accumsan felis. Ut at dolor quis odio consequat varius. Integer ac leo. Pellentesque ultrices mattis odio.",
            id: "10bceaf2-242d-4406-88e5-7ae47d748e62",
            page_number: 291,
          },
          {
            note_type: "connection",
            highlight:
              "Proin interdum mauris non ligula pellentesque ultrices. Phasellus id sapien in sapien iaculis congue.",
            content: "Nulla tellus. In sagittis dui vel nisl. Duis ac nibh.",
            id: "f6e49bc8-a0c9-4951-8d79-45b418b17f15",
            page_number: 201,
          },
          {
            note_type: "concept",
            highlight:
              "Quisque erat eros, viverra eget, congue eget, semper rutrum, nulla.",
            content:
              "Morbi a ipsum. Integer a nibh. In quis justo. Maecenas rhoncus aliquam lacus. Morbi quis tortor id nulla ultrices aliquet.",
            id: "27e18e72-fed1-4210-9d73-ba7929d4de63",
            page_number: 221,
          },
        ],
      },
    ],
  },
  {
    isbn: "764731358-4",
    title: "Immortals",
    authors: ["Shell Patifield"],
    cover_image_url: "http://dummyimage.com/194x100.png/dddddd/000000",
    is_fiction: true,
    tags: ["Western"],
    summary: "Nulla nisl. Nunc nisl.",
    pinned: false,
    active: false,
    chapters: [
      {
        id: "793ff258-1b14-4c6c-bc8a-3d3a0ad16c45",
        title: "Harbor seal",
        chapter_number: 1,
        sort_order: 1,
        summary: "Suspendisse potenti.",
        notes: [
          {
            note_type: "quote",
            highlight:
              "Proin interdum mauris non ligula pellentesque ultrices. Phasellus id sapien in sapien iaculis congue.",
            content:
              "Vestibulum sed magna at nunc commodo placerat. Praesent blandit. Nam nulla. Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede. Morbi porttitor lorem id ligula.",
            id: "e3194244-5c58-42af-a6de-51d7889d333b",
            page_number: 80,
          },
          {
            note_type: "connection",
            highlight:
              "In tempor, turpis nec euismod scelerisque, quam turpis adipiscing lorem, vitae mattis nibh ligula nec sem. Duis aliquam convallis nunc. Proin at turpis a pede posuere nonummy.",
            content:
              "Praesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio. Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo.",
            id: "32fb76db-a7c9-46a5-9ff5-03e73974211f",
            page_number: 17,
          },
          {
            note_type: "quote",
            highlight: "Donec semper sapien a libero.",
            content:
              "Etiam justo. Etiam pretium iaculis justo. In hac habitasse platea dictumst.",
            id: "11ffa311-4d2b-4c00-bfd2-18e2043f5abb",
            page_number: 314,
          },
          {
            note_type: "thought",
            highlight: "Sed accumsan felis.",
            content:
              "Donec semper sapien a libero. Nam dui. Proin leo odio, porttitor id, consequat in, consequat ut, nulla. Sed accumsan felis.",
            id: "881f0391-3124-4a84-b7cf-62bfc18df34b",
            page_number: 165,
          },
          {
            note_type: "connection",
            highlight: "Quisque ut erat.",
            content:
              "Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.",
            id: "1920bea8-0abd-4f3d-9a64-0f154491d3cd",
            page_number: 239,
          },
        ],
      },
      {
        id: "8e630d4a-160b-489f-b772-93b2409f3bc2",
        title: "Chickadee, black-capped",
        chapter_number: 2,
        sort_order: 2,
        summary: "Suspendisse potenti.",
        notes: [
          {
            note_type: "quote",
            highlight:
              "Proin leo odio, porttitor id, consequat in, consequat ut, nulla. Sed accumsan felis. Ut at dolor quis odio consequat varius.",
            content:
              "Pellentesque at nulla. Suspendisse potenti. Cras in purus eu magna vulputate luctus. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien.",
            id: "88032f50-c835-45c3-98a0-fc445d715d21",
            page_number: 262,
          },
          {
            note_type: "quote",
            highlight: "Nulla suscipit ligula in lacus.",
            content:
              "Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla. Sed vel enim sit amet nunc viverra dapibus. Nulla suscipit ligula in lacus.",
            id: "e5f5a404-4274-4a7c-8753-28099438fab6",
            page_number: 245,
          },
          {
            note_type: "connection",
            highlight: "Nulla nisl.",
            content:
              "Nullam molestie nibh in lectus. Pellentesque at nulla. Suspendisse potenti. Cras in purus eu magna vulputate luctus.",
            id: "d27c4643-7d97-4954-acc2-01f76886949f",
            page_number: 36,
          },
        ],
      },
    ],
  },
  {
    isbn: "516134140-8",
    title: "Reel Rock 7 ",
    authors: [
      "Almire Mustarde",
      "Trevor Svanini",
      "Stefanie Collum",
      "Dal Calles",
      "Bernie Dwight",
    ],
    cover_image_url: "http://dummyimage.com/195x100.png/cc0000/ffffff",
    is_fiction: true,
    tags: ["Drama|Romance"],
    summary:
      "Suspendisse potenti. Cras in purus eu magna vulputate luctus. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
    pinned: false,
    active: false,
    chapters: [
      {
        id: "34c58f84-28da-4c9f-bb55-fd3cb0d051a8",
        title: "Arctic fox",
        chapter_number: 1,
        sort_order: 1,
        summary:
          "Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede. Morbi porttitor lorem id ligula.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "Proin risus. Praesent lectus. Vestibulum quam sapien, varius ut, blandit non, interdum in, ante.",
            content:
              "Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo. Pellentesque viverra pede ac diam. Cras pellentesque volutpat dui. Maecenas tristique, est et tempus semper, est quam pharetra magna, ac consequat metus sapien ut nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Mauris viverra diam vitae quam.",
            id: "d835985e-169a-4c70-b6e4-aac6cae12ad9",
            page_number: 225,
          },
          {
            note_type: "connection",
            highlight: "Nulla tellus. In sagittis dui vel nisl. Duis ac nibh.",
            content:
              "Proin risus. Praesent lectus. Vestibulum quam sapien, varius ut, blandit non, interdum in, ante.",
            id: "a4b9c660-6154-4b1e-87b3-2d2619e2f3ca",
            page_number: 276,
          },
        ],
      },
      {
        id: "042623ec-9e57-484a-aa09-5fdb0188537f",
        title: "Cape cobra",
        chapter_number: 2,
        sort_order: 2,
        summary: "Nunc rhoncus dui vel sem. Sed sagittis.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "Integer tincidunt ante vel ipsum. Praesent blandit lacinia erat. Vestibulum sed magna at nunc commodo placerat.",
            content:
              "Aenean auctor gravida sem. Praesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.",
            id: "47e59fec-023e-4a21-b0ac-6c74cd04f035",
            page_number: 146,
          },
          {
            note_type: "definition",
            highlight:
              "Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede.",
            content:
              "Aenean sit amet justo. Morbi ut odio. Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo. In blandit ultrices enim.",
            id: "a2e19abb-88f9-40fd-a15a-c5fed90c1b0f",
            page_number: 115,
          },
        ],
      },
    ],
  },
  {
    isbn: "054421714-4",
    title: "Men in White",
    authors: [
      "Garvey Shouler",
      "Elspeth Braddick",
      "Pat Bernardeau",
      "Kirbie Toller",
    ],
    cover_image_url: "http://dummyimage.com/205x100.png/5fa2dd/ffffff",
    is_fiction: true,
    tags: ["Documentary", "Documentary", "Horror|Thriller"],
    summary:
      "Nunc rhoncus dui vel sem. Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci.",
    pinned: false,
    active: false,
    chapters: [
      {
        id: "317b4ab6-d383-48c5-88c0-c0418f9792ea",
        title: "Two-toed tree sloth",
        chapter_number: 1,
        sort_order: 1,
        summary:
          "Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id, turpis.",
        notes: [
          {
            note_type: "quote",
            highlight:
              "Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id, turpis. Integer aliquet, massa id lobortis convallis, tortor risus dapibus augue, vel accumsan tellus nisi eu orci.",
            content:
              "Nunc rhoncus dui vel sem. Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus. Pellentesque at nulla.",
            id: "003225e2-c4c8-451d-9e63-f58f7a6771b8",
            page_number: 379,
          },
          {
            note_type: "quote",
            highlight:
              "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
            content:
              "Integer aliquet, massa id lobortis convallis, tortor risus dapibus augue, vel accumsan tellus nisi eu orci. Mauris lacinia sapien quis libero. Nullam sit amet turpis elementum ligula vehicula consequat. Morbi a ipsum.",
            id: "e8284548-6070-4ad8-a3b8-d8c8aa99c6be",
            page_number: 102,
          },
          {
            note_type: "thought",
            highlight:
              "Quisque id justo sit amet sapien dignissim vestibulum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est.",
            content:
              "Duis consequat dui nec nisi volutpat eleifend. Donec ut dolor. Morbi vel lectus in quam fringilla rhoncus. Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id, turpis.",
            id: "52837224-aef4-4147-8827-f1c843a2d23e",
            page_number: 259,
          },
        ],
      },
      {
        id: "18ad442f-05a0-4a72-a7f3-1a1468e37f12",
        title: "Macaw, scarlet",
        chapter_number: 2,
        sort_order: 2,
        summary:
          "Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi.",
        notes: [
          {
            note_type: "thought",
            highlight: "Sed sagittis.",
            content:
              "Ut tellus. Nulla ut erat id mauris vulputate elementum. Nullam varius.",
            id: "20dfd116-c750-4d28-af4a-9b15d70f9dc4",
            page_number: 130,
          },
          {
            note_type: "concept",
            highlight:
              "Fusce lacus purus, aliquet at, feugiat non, pretium quis, lectus. Suspendisse potenti. In eleifend quam a odio.",
            content:
              "Duis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa. Donec dapibus. Duis at velit eu est congue elementum. In hac habitasse platea dictumst.",
            id: "8a720b08-2d8f-42a3-b3af-75e4aea2254a",
            page_number: 171,
          },
          {
            note_type: "quote",
            highlight:
              "Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem.",
            content:
              "Nullam porttitor lacus at turpis. Donec posuere metus vitae ipsum. Aliquam non mauris.",
            id: "925581be-4589-4ecb-9c05-a2b1519dda30",
            page_number: 37,
          },
          {
            note_type: "definition",
            highlight:
              "Fusce lacus purus, aliquet at, feugiat non, pretium quis, lectus. Suspendisse potenti. In eleifend quam a odio.",
            content:
              "Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis. Fusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl.",
            id: "f5317503-df07-4c7b-a09f-4ea5907a20d2",
            page_number: 35,
          },
        ],
      },
      {
        id: "ee39927c-5bcf-4dea-b7f7-b633eccf676c",
        title: "Prehensile-tailed porcupine",
        chapter_number: 3,
        sort_order: 3,
        summary:
          "In blandit ultrices enim. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede. Morbi porttitor lorem id ligula. Suspendisse ornare consequat lectus.",
            content:
              "Sed ante. Vivamus tortor. Duis mattis egestas metus. Aenean fermentum. Donec ut mauris eget massa tempor convallis.",
            id: "c482edf8-94c8-4fef-b1c4-c4d00eb87088",
            page_number: 350,
          },
          {
            note_type: "connection",
            highlight:
              "Nulla ut erat id mauris vulputate elementum. Nullam varius.",
            content:
              "Proin eu mi. Nulla ac enim. In tempor, turpis nec euismod scelerisque, quam turpis adipiscing lorem, vitae mattis nibh ligula nec sem. Duis aliquam convallis nunc.",
            id: "2671fe79-0161-4044-a745-1189194fa538",
            page_number: 352,
          },
          {
            note_type: "thought",
            highlight:
              "Etiam justo. Etiam pretium iaculis justo. In hac habitasse platea dictumst.",
            content:
              "Morbi porttitor lorem id ligula. Suspendisse ornare consequat lectus. In est risus, auctor sed, tristique in, tempus sit amet, sem. Fusce consequat. Nulla nisl.",
            id: "f3efea0f-62e2-4339-a8e9-ab70c91a55fe",
            page_number: 399,
          },
        ],
      },
    ],
  },
  {
    isbn: "423486862-0",
    title: "Battle Creek Brawl (Big Brawl, The)",
    authors: ["Marguerite MacHoste", "Fernanda Kynge", "Mathe Lomasney"],
    cover_image_url: "http://dummyimage.com/100x100.png/dddddd/000000",
    is_fiction: false,
    tags: ["Drama|Fantasy|Romance|Sci-Fi", "Crime|Drama", "Drama", "Horror"],
    summary: "Mauris sit amet eros.",
    pinned: false,
    active: false,
    chapters: [
      {
        id: "55204ac3-45f0-444a-808f-410dcbb1c60d",
        title: "Screamer, crested",
        chapter_number: 1,
        sort_order: 1,
        summary:
          "Fusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl.",
        notes: [
          {
            note_type: "concept",
            highlight: "Fusce consequat.",
            content:
              "Duis mattis egestas metus. Aenean fermentum. Donec ut mauris eget massa tempor convallis. Nulla neque libero, convallis eget, eleifend luctus, ultricies eu, nibh. Quisque id justo sit amet sapien dignissim vestibulum.",
            id: "0eeabf81-16da-432d-98cf-92b4a23ecb1d",
            page_number: 8,
          },
          {
            note_type: "definition",
            highlight:
              "Donec semper sapien a libero. Nam dui. Proin leo odio, porttitor id, consequat in, consequat ut, nulla.",
            content:
              "Morbi a ipsum. Integer a nibh. In quis justo. Maecenas rhoncus aliquam lacus. Morbi quis tortor id nulla ultrices aliquet.",
            id: "8bd816ec-05b2-40bf-a19b-cfe01387bd9c",
            page_number: 179,
          },
          {
            note_type: "thought",
            highlight:
              "Vivamus in felis eu sapien cursus vestibulum. Proin eu mi. Nulla ac enim.",
            content:
              "Vivamus in felis eu sapien cursus vestibulum. Proin eu mi. Nulla ac enim. In tempor, turpis nec euismod scelerisque, quam turpis adipiscing lorem, vitae mattis nibh ligula nec sem.",
            id: "0afbc517-aee2-4ffa-8ed5-a6a6c650d7cc",
            page_number: 157,
          },
          {
            note_type: "concept",
            highlight:
              "Integer a nibh. In quis justo. Maecenas rhoncus aliquam lacus.",
            content:
              "Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo. Pellentesque viverra pede ac diam. Cras pellentesque volutpat dui. Maecenas tristique, est et tempus semper, est quam pharetra magna, ac consequat metus sapien ut nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Mauris viverra diam vitae quam.",
            id: "9026c372-43d7-4e6e-98f6-826d19400658",
            page_number: 108,
          },
        ],
      },
      {
        id: "3c0a3a8d-e8eb-42ab-a428-f548cef1dd2c",
        title: "Vulture, black",
        chapter_number: 2,
        sort_order: 2,
        summary:
          "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "In hac habitasse platea dictumst. Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante. Nulla justo.",
            content:
              "Nulla ut erat id mauris vulputate elementum. Nullam varius. Nulla facilisi.",
            id: "924c6cc6-45ec-4559-b704-1de4e2ef5622",
            page_number: 150,
          },
          {
            note_type: "connection",
            highlight: "Ut tellus.",
            content:
              "Integer aliquet, massa id lobortis convallis, tortor risus dapibus augue, vel accumsan tellus nisi eu orci. Mauris lacinia sapien quis libero. Nullam sit amet turpis elementum ligula vehicula consequat.",
            id: "86de2bcb-9a14-4823-bade-9f1fe1a0aaff",
            page_number: 55,
          },
        ],
      },
      {
        id: "e853fea1-97b5-44c2-bfbc-f58f890dcf95",
        title: "Long-tailed spotted cat",
        chapter_number: 3,
        sort_order: 3,
        summary: "Donec ut dolor.",
        notes: [
          {
            note_type: "concept",
            highlight: "Suspendisse potenti. In eleifend quam a odio.",
            content:
              "Phasellus sit amet erat. Nulla tempus. Vivamus in felis eu sapien cursus vestibulum. Proin eu mi.",
            id: "574ee084-282e-44be-b609-a62d166bbb70",
            page_number: 160,
          },
          {
            note_type: "quote",
            highlight:
              "In hac habitasse platea dictumst. Maecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem.",
            content:
              "Sed vel enim sit amet nunc viverra dapibus. Nulla suscipit ligula in lacus. Curabitur at ipsum ac tellus semper interdum.",
            id: "f524750c-2d53-4662-b698-5b4b4d333785",
            page_number: 180,
          },
          {
            note_type: "connection",
            highlight:
              "Nulla ut erat id mauris vulputate elementum. Nullam varius. Nulla facilisi.",
            content:
              "Nunc rhoncus dui vel sem. Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus.",
            id: "b1ffca01-f1ec-466d-a8e4-630ec74f4d1e",
            page_number: 55,
          },
        ],
      },
    ],
  },
  {
    isbn: "512110249-6",
    title: "Kosmos",
    authors: [
      "Mariel Utton",
      "Izabel Jenicke",
      "Katalin Duval",
      "Alasdair Ofield",
      "Pancho Crummay",
    ],
    cover_image_url: "http://dummyimage.com/101x100.png/dddddd/000000",
    is_fiction: false,
    tags: ["Documentary"],
    summary:
      "Cras non velit nec nisi vulputate nonummy. Maecenas tincidunt lacus at velit. Vivamus vel nulla eget eros elementum pellentesque.",
    pinned: false,
    active: false,
    chapters: [
      {
        id: "60f0ebbf-a52b-4b06-9916-38e4664c4ddf",
        title: "Red-shouldered glossy starling",
        chapter_number: 1,
        sort_order: 1,
        summary: "Phasellus in felis. Donec semper sapien a libero.",
        notes: [
          {
            note_type: "definition",
            highlight: "Suspendisse potenti. Nullam porttitor lacus at turpis.",
            content:
              "Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo. In blandit ultrices enim. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
            id: "2bc79980-a2aa-4625-bbc9-ea8e8ba8205a",
            page_number: 286,
          },
          {
            note_type: "quote",
            highlight:
              "Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus.",
            content:
              "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin interdum mauris non ligula pellentesque ultrices. Phasellus id sapien in sapien iaculis congue.",
            id: "98f06eca-3397-4b37-8a29-280cc163df21",
            page_number: 121,
          },
        ],
      },
      {
        id: "3da2ebe9-041d-4838-a0ed-b73e4345df2b",
        title: "Short-beaked echidna",
        chapter_number: 2,
        sort_order: 2,
        summary:
          "Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id, turpis.",
        notes: [
          {
            note_type: "concept",
            highlight: "Etiam faucibus cursus urna. Ut tellus.",
            content:
              "Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus. Pellentesque at nulla. Suspendisse potenti. Cras in purus eu magna vulputate luctus.",
            id: "9bd1d9f9-4fd3-4732-a3a3-dbde9978a78e",
            page_number: 163,
          },
          {
            note_type: "quote",
            highlight:
              "Maecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem.",
            content:
              "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum.",
            id: "dc51d198-fec2-4046-9c42-a8f5c3e88cb8",
            page_number: 9,
          },
          {
            note_type: "concept",
            highlight:
              "Mauris ullamcorper purus sit amet nulla. Quisque arcu libero, rutrum ac, lobortis vel, dapibus at, diam.",
            content:
              "Vivamus in felis eu sapien cursus vestibulum. Proin eu mi. Nulla ac enim.",
            id: "125abf0c-ae0d-462a-b5cb-d3a14eb38178",
            page_number: 257,
          },
          {
            note_type: "thought",
            highlight:
              "Proin leo odio, porttitor id, consequat in, consequat ut, nulla. Sed accumsan felis. Ut at dolor quis odio consequat varius.",
            content:
              "Morbi porttitor lorem id ligula. Suspendisse ornare consequat lectus. In est risus, auctor sed, tristique in, tempus sit amet, sem. Fusce consequat. Nulla nisl.",
            id: "97c3d3a8-c0f0-4648-aa37-94d2269df4aa",
            page_number: 58,
          },
        ],
      },
      {
        id: "a003ce79-8a7e-427d-aee8-cac58e3624f8",
        title: "Greater roadrunner",
        chapter_number: 3,
        sort_order: 3,
        summary: "Nulla facilisi. Cras non velit nec nisi vulputate nonummy.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "Quisque id justo sit amet sapien dignissim vestibulum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est.",
            content:
              "In sagittis dui vel nisl. Duis ac nibh. Fusce lacus purus, aliquet at, feugiat non, pretium quis, lectus.",
            id: "589921eb-a456-4ca8-909a-09a3c18d5330",
            page_number: 105,
          },
          {
            note_type: "definition",
            highlight:
              "Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat. In congue.",
            content:
              "In sagittis dui vel nisl. Duis ac nibh. Fusce lacus purus, aliquet at, feugiat non, pretium quis, lectus. Suspendisse potenti.",
            id: "fe713965-5b01-4ddf-a4e6-58c313ac7e29",
            page_number: 305,
          },
          {
            note_type: "definition",
            highlight:
              "Quisque porta volutpat erat. Quisque erat eros, viverra eget, congue eget, semper rutrum, nulla. Nunc purus.",
            content:
              "Nam nulla. Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede. Morbi porttitor lorem id ligula.",
            id: "f6869626-ef11-4956-94c2-22bfbec05b26",
            page_number: 158,
          },
          {
            note_type: "quote",
            highlight: "Vivamus vestibulum sagittis sapien.",
            content:
              "Morbi non lectus. Aliquam sit amet diam in magna bibendum imperdiet. Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis. Fusce posuere felis sed lacus.",
            id: "08e85dfa-1386-4536-bfb9-d352fc037e19",
            page_number: 281,
          },
        ],
      },
      {
        id: "fcc76f4b-9c7e-4426-bb96-f2924f6db3b3",
        title: "Wallaby, tammar",
        chapter_number: 4,
        sort_order: 4,
        summary: "Maecenas rhoncus aliquam lacus.",
        notes: [
          {
            note_type: "quote",
            highlight:
              "Vivamus metus arcu, adipiscing molestie, hendrerit at, vulputate vitae, nisl. Aenean lectus. Pellentesque eget nunc.",
            content:
              "Pellentesque eget nunc. Donec quis orci eget orci vehicula condimentum. Curabitur in libero ut massa volutpat convallis.",
            id: "7e2a3882-b7b8-435c-b41e-f4316a74ea7d",
            page_number: 327,
          },
          {
            note_type: "concept",
            highlight:
              "Morbi ut odio. Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo.",
            content:
              "Etiam justo. Etiam pretium iaculis justo. In hac habitasse platea dictumst. Etiam faucibus cursus urna. Ut tellus.",
            id: "46ae1f8d-f6f7-4bfe-b4d4-8f9abfc22822",
            page_number: 81,
          },
          {
            note_type: "connection",
            highlight:
              "Duis at velit eu est congue elementum. In hac habitasse platea dictumst. Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante.",
            content:
              "Nam nulla. Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede. Morbi porttitor lorem id ligula.",
            id: "4be756ed-9d87-4c0f-8a45-b28bd11af483",
            page_number: 364,
          },
          {
            note_type: "connection",
            highlight: "Phasellus id sapien in sapien iaculis congue.",
            content:
              "Integer a nibh. In quis justo. Maecenas rhoncus aliquam lacus. Morbi quis tortor id nulla ultrices aliquet. Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo.",
            id: "8c551def-a46f-4a90-ae12-85f38b38e3c3",
            page_number: 121,
          },
          {
            note_type: "definition",
            highlight:
              "Morbi quis tortor id nulla ultrices aliquet. Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo. Pellentesque viverra pede ac diam.",
            content:
              "Pellentesque ultrices mattis odio. Donec vitae nisi. Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla.",
            id: "32dfad15-ff95-4c80-9ec2-f65ec7447a66",
            page_number: 242,
          },
        ],
      },
      {
        id: "0be11aa9-a7e2-4838-9f90-783871d740bb",
        title: "Cormorant, little",
        chapter_number: 5,
        sort_order: 5,
        summary: "Morbi a ipsum. Integer a nibh.",
        notes: [
          {
            note_type: "quote",
            highlight: "In sagittis dui vel nisl.",
            content:
              "Etiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem. Praesent id massa id nisl venenatis lacinia.",
            id: "f5e1eb9a-2c1a-4781-a11a-db58cfd81b92",
            page_number: 399,
          },
          {
            note_type: "thought",
            highlight:
              "Praesent blandit lacinia erat. Vestibulum sed magna at nunc commodo placerat. Praesent blandit.",
            content:
              "Nunc purus. Phasellus in felis. Donec semper sapien a libero.",
            id: "1334961f-7a70-44b8-956a-a4e29ffcb308",
            page_number: 279,
          },
          {
            note_type: "definition",
            highlight:
              "Curabitur gravida nisi at nibh. In hac habitasse platea dictumst. Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem.",
            content:
              "Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo. In blandit ultrices enim. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin interdum mauris non ligula pellentesque ultrices.",
            id: "15bdad87-1ef1-4404-82aa-be9e8cccb728",
            page_number: 108,
          },
        ],
      },
    ],
  },
  {
    isbn: "484821195-6",
    title: "At Middleton",
    authors: ["Lotte Oswald", "Amalea Caudwell", "Haley Dumbreck"],
    cover_image_url: "http://dummyimage.com/245x100.png/dddddd/000000",
    is_fiction: true,
    tags: ["Adventure|Drama"],
    summary: "Quisque arcu libero, rutrum ac, lobortis vel, dapibus at, diam.",
    pinned: true,
    active: false,
    chapters: [
      {
        id: "e24ff153-0a16-4e95-a096-f3add76e2ca1",
        title: "Heron, green-backed",
        chapter_number: 1,
        sort_order: 1,
        summary: "Donec quis orci eget orci vehicula condimentum.",
        notes: [
          {
            note_type: "quote",
            highlight:
              "Maecenas rhoncus aliquam lacus. Morbi quis tortor id nulla ultrices aliquet.",
            content:
              "Nullam varius. Nulla facilisi. Cras non velit nec nisi vulputate nonummy. Maecenas tincidunt lacus at velit. Vivamus vel nulla eget eros elementum pellentesque.",
            id: "2c9de142-36ee-4b23-bd85-1591a08a88fd",
            page_number: 338,
          },
          {
            note_type: "thought",
            highlight: "Vivamus vestibulum sagittis sapien.",
            content:
              "Pellentesque viverra pede ac diam. Cras pellentesque volutpat dui. Maecenas tristique, est et tempus semper, est quam pharetra magna, ac consequat metus sapien ut nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Mauris viverra diam vitae quam. Suspendisse potenti.",
            id: "851ef38b-b083-4953-8da6-90bb78911a19",
            page_number: 320,
          },
          {
            note_type: "concept",
            highlight: "In sagittis dui vel nisl.",
            content:
              "Morbi ut odio. Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo. In blandit ultrices enim. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin interdum mauris non ligula pellentesque ultrices.",
            id: "9b970580-f92e-46b4-bdc3-7fd1d99fa283",
            page_number: 184,
          },
          {
            note_type: "definition",
            highlight:
              "In hac habitasse platea dictumst. Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante. Nulla justo.",
            content:
              "Nam dui. Proin leo odio, porttitor id, consequat in, consequat ut, nulla. Sed accumsan felis. Ut at dolor quis odio consequat varius.",
            id: "31a1b0ed-87c9-409c-86ff-e963bc100cf7",
            page_number: 335,
          },
          {
            note_type: "quote",
            highlight:
              "Maecenas tincidunt lacus at velit. Vivamus vel nulla eget eros elementum pellentesque.",
            content:
              "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est. Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros. Vestibulum ac est lacinia nisi venenatis tristique. Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat.",
            id: "37e5aca5-cd3b-4904-ab10-941816381947",
            page_number: 399,
          },
        ],
      },
      {
        id: "8a895433-c125-4b96-bb34-7c3ba921a38e",
        title: "Giant anteater",
        chapter_number: 2,
        sort_order: 2,
        summary: "Nulla ut erat id mauris vulputate elementum.",
        notes: [
          {
            note_type: "thought",
            highlight: "Pellentesque at nulla. Suspendisse potenti.",
            content:
              "Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo. Pellentesque viverra pede ac diam. Cras pellentesque volutpat dui. Maecenas tristique, est et tempus semper, est quam pharetra magna, ac consequat metus sapien ut nunc.",
            id: "4efe6c17-ce13-49db-a4be-7cd044328b06",
            page_number: 201,
          },
          {
            note_type: "connection",
            highlight:
              "Duis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa.",
            content:
              "Integer ac leo. Pellentesque ultrices mattis odio. Donec vitae nisi. Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla. Sed vel enim sit amet nunc viverra dapibus.",
            id: "ecb044f9-b511-4298-a9ab-1b06305a2e50",
            page_number: 212,
          },
          {
            note_type: "connection",
            highlight:
              "Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id, turpis. Integer aliquet, massa id lobortis convallis, tortor risus dapibus augue, vel accumsan tellus nisi eu orci.",
            content:
              "Proin interdum mauris non ligula pellentesque ultrices. Phasellus id sapien in sapien iaculis congue. Vivamus metus arcu, adipiscing molestie, hendrerit at, vulputate vitae, nisl.",
            id: "34d869e0-44c8-4526-8f73-9cd942fd5e6f",
            page_number: 75,
          },
          {
            note_type: "thought",
            highlight: "Praesent id massa id nisl venenatis lacinia.",
            content:
              "Praesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio. Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo.",
            id: "b80e3ff6-5b62-4dd2-a058-062bd87f7cc5",
            page_number: 122,
          },
          {
            note_type: "definition",
            highlight:
              "Curabitur in libero ut massa volutpat convallis. Morbi odio odio, elementum eu, interdum eu, tincidunt in, leo. Maecenas pulvinar lobortis est.",
            content:
              "Curabitur convallis. Duis consequat dui nec nisi volutpat eleifend. Donec ut dolor. Morbi vel lectus in quam fringilla rhoncus. Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id, turpis.",
            id: "6026641f-06a1-48d8-a779-d1235647fdbb",
            page_number: 205,
          },
        ],
      },
      {
        id: "d405189f-f893-4d60-ac67-ac4a634d57f9",
        title: "South American puma",
        chapter_number: 3,
        sort_order: 3,
        summary:
          "Aenean auctor gravida sem. Praesent id massa id nisl venenatis lacinia.",
        notes: [
          {
            note_type: "connection",
            highlight:
              "Cras non velit nec nisi vulputate nonummy. Maecenas tincidunt lacus at velit. Vivamus vel nulla eget eros elementum pellentesque.",
            content:
              "Phasellus in felis. Donec semper sapien a libero. Nam dui.",
            id: "9c2fbe07-a8e6-4199-a2b2-bf276ed3581e",
            page_number: 368,
          },
          {
            note_type: "quote",
            highlight:
              "Aliquam sit amet diam in magna bibendum imperdiet. Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis.",
            content:
              "Fusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl. Nunc rhoncus dui vel sem. Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci.",
            id: "ed8a8abc-252d-4936-be94-93966c1dfa3a",
            page_number: 209,
          },
          {
            note_type: "quote",
            highlight:
              "Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis.",
            content:
              "Suspendisse ornare consequat lectus. In est risus, auctor sed, tristique in, tempus sit amet, sem. Fusce consequat.",
            id: "3c9ac5b4-f944-4efe-a054-e0e3770c24a3",
            page_number: 276,
          },
        ],
      },
      {
        id: "9defc504-a247-490f-9989-7564fb556447",
        title: "Greater adjutant stork",
        chapter_number: 4,
        sort_order: 4,
        summary: "Donec vitae nisi.",
        notes: [
          {
            note_type: "connection",
            highlight:
              "Etiam pretium iaculis justo. In hac habitasse platea dictumst.",
            content:
              "Ut tellus. Nulla ut erat id mauris vulputate elementum. Nullam varius. Nulla facilisi. Cras non velit nec nisi vulputate nonummy.",
            id: "b61fa875-7880-4e24-9f4f-06ae06a63767",
            page_number: 132,
          },
          {
            note_type: "quote",
            highlight: "Nunc purus.",
            content:
              "Nulla nisl. Nunc nisl. Duis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa. Donec dapibus. Duis at velit eu est congue elementum.",
            id: "8d73250d-1ddd-434e-b145-f450155d5ba8",
            page_number: 108,
          },
        ],
      },
    ],
  },
  {
    isbn: "305998466-2",
    title: "Whistle Blower, The",
    authors: ["Stoddard Janosevic", "La verne Riglesford", "Myrta Liverseege"],
    cover_image_url: "http://dummyimage.com/222x100.png/cc0000/ffffff",
    is_fiction: false,
    tags: ["Drama"],
    summary: "Nulla nisl.",
    pinned: true,
    active: false,
    chapters: [
      {
        id: "24ba0fed-8a85-4b50-8d6f-8db12b01b103",
        title: "Lemur, ring-tailed",
        chapter_number: 1,
        sort_order: 1,
        summary:
          "In hac habitasse platea dictumst. Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "Proin leo odio, porttitor id, consequat in, consequat ut, nulla.",
            content:
              "Phasellus sit amet erat. Nulla tempus. Vivamus in felis eu sapien cursus vestibulum. Proin eu mi. Nulla ac enim.",
            id: "83d2dbb6-d231-42d9-9746-96264cbc8f86",
            page_number: 280,
          },
          {
            note_type: "definition",
            highlight:
              "Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.",
            content:
              "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque.",
            id: "4d19239d-2d8c-4e85-b47f-94dbfc6b071c",
            page_number: 188,
          },
          {
            note_type: "thought",
            highlight:
              "Vivamus metus arcu, adipiscing molestie, hendrerit at, vulputate vitae, nisl. Aenean lectus. Pellentesque eget nunc.",
            content:
              "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum. Nulla tellus.",
            id: "be9b0bd9-7787-454f-a048-3a0b8c9640b7",
            page_number: 380,
          },
          {
            note_type: "concept",
            highlight:
              "Duis at velit eu est congue elementum. In hac habitasse platea dictumst. Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante.",
            content:
              "Donec ut dolor. Morbi vel lectus in quam fringilla rhoncus. Mauris enim leo, rhoncus sed, vestibulum sit amet, cursus id, turpis. Integer aliquet, massa id lobortis convallis, tortor risus dapibus augue, vel accumsan tellus nisi eu orci.",
            id: "7b76abfe-600a-47dc-9092-c81f00dd18ce",
            page_number: 240,
          },
        ],
      },
      {
        id: "41b1ae8b-2b18-446e-a6b1-68ebcdf5820c",
        title: "Roan antelope",
        chapter_number: 2,
        sort_order: 2,
        summary:
          "Cras pellentesque volutpat dui. Maecenas tristique, est et tempus semper, est quam pharetra magna, ac consequat metus sapien ut nunc.",
        notes: [
          {
            note_type: "concept",
            highlight: "Nulla tellus. In sagittis dui vel nisl.",
            content:
              "Maecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat. Curabitur gravida nisi at nibh. In hac habitasse platea dictumst.",
            id: "b7065c33-25d7-4993-a027-401d569b271e",
            page_number: 384,
          },
          {
            note_type: "concept",
            highlight:
              "Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros.",
            content:
              "Nunc nisl. Duis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa. Donec dapibus. Duis at velit eu est congue elementum.",
            id: "12848a98-8c3e-4d65-a18f-1c87d817d651",
            page_number: 96,
          },
        ],
      },
      {
        id: "66519134-ed4a-4466-9a54-8d4b9217a630",
        title: "Cat, miner's",
        chapter_number: 3,
        sort_order: 3,
        summary: "Sed accumsan felis. Ut at dolor quis odio consequat varius.",
        notes: [
          {
            note_type: "quote",
            highlight:
              "Proin interdum mauris non ligula pellentesque ultrices.",
            content:
              "Morbi a ipsum. Integer a nibh. In quis justo. Maecenas rhoncus aliquam lacus.",
            id: "8882bd84-10c8-4140-9bf5-a699bbf147c8",
            page_number: 46,
          },
          {
            note_type: "thought",
            highlight:
              "Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi.",
            content:
              "Praesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.",
            id: "1414a7ef-19cf-4c1e-a789-8c585eaf2007",
            page_number: 73,
          },
        ],
      },
    ],
  },
  {
    isbn: "532544570-7",
    title: "Estomago: A Gastronomic Story",
    authors: ["Lillis Lamball"],
    cover_image_url: "http://dummyimage.com/205x100.png/cc0000/ffffff",
    is_fiction: false,
    tags: ["Drama", "Drama", "Drama", "Documentary", "Comedy|Crime"],
    summary: "Morbi non quam nec dui luctus rutrum. Nulla tellus.",
    pinned: true,
    active: false,
    chapters: [
      {
        id: "0a9c9f3b-72cb-41f3-8aa1-6c42ee66ca76",
        title: "Yellow-headed caracara",
        chapter_number: 1,
        sort_order: 1,
        summary:
          "Maecenas tincidunt lacus at velit. Vivamus vel nulla eget eros elementum pellentesque.",
        notes: [
          {
            note_type: "quote",
            highlight:
              "Proin leo odio, porttitor id, consequat in, consequat ut, nulla.",
            content:
              "Nulla justo. Aliquam quis turpis eget elit sodales scelerisque. Mauris sit amet eros. Suspendisse accumsan tortor quis turpis.",
            id: "24bb3a1d-a92f-4c9d-9e90-e65e6b121551",
            page_number: 108,
          },
          {
            note_type: "connection",
            highlight:
              "Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus.",
            content:
              "Cras pellentesque volutpat dui. Maecenas tristique, est et tempus semper, est quam pharetra magna, ac consequat metus sapien ut nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Mauris viverra diam vitae quam. Suspendisse potenti.",
            id: "1b7f8bf4-eeae-4c7e-b902-4d624853e772",
            page_number: 265,
          },
          {
            note_type: "quote",
            highlight:
              "Nunc nisl. Duis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa.",
            content:
              "Aenean sit amet justo. Morbi ut odio. Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo. In blandit ultrices enim.",
            id: "eb4cb52a-59b4-4b32-a17b-dca5ec4aedaa",
            page_number: 318,
          },
          {
            note_type: "thought",
            highlight: "Vivamus vestibulum sagittis sapien.",
            content:
              "Integer tincidunt ante vel ipsum. Praesent blandit lacinia erat. Vestibulum sed magna at nunc commodo placerat. Praesent blandit.",
            id: "ad3227aa-64be-438a-9cb8-c4e6546e7d0d",
            page_number: 139,
          },
        ],
      },
      {
        id: "a635b76e-1e5b-47f5-a3f3-2ce3f91e3c55",
        title: "Egret, snowy",
        chapter_number: 2,
        sort_order: 2,
        summary: "Nulla mollis molestie lorem. Quisque ut erat.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis faucibus accumsan odio. Curabitur convallis.",
            content:
              "Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis. Fusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl. Nunc rhoncus dui vel sem. Sed sagittis.",
            id: "f5976ff0-b968-4c27-95cc-4b1763a96364",
            page_number: 213,
          },
          {
            note_type: "definition",
            highlight:
              "Aliquam non mauris. Morbi non lectus. Aliquam sit amet diam in magna bibendum imperdiet.",
            content:
              "In tempor, turpis nec euismod scelerisque, quam turpis adipiscing lorem, vitae mattis nibh ligula nec sem. Duis aliquam convallis nunc. Proin at turpis a pede posuere nonummy. Integer non velit.",
            id: "8afb6f0e-23b6-4deb-a67e-e395b96a79e6",
            page_number: 346,
          },
          {
            note_type: "thought",
            highlight: "Sed ante.",
            content:
              "Nulla suscipit ligula in lacus. Curabitur at ipsum ac tellus semper interdum. Mauris ullamcorper purus sit amet nulla. Quisque arcu libero, rutrum ac, lobortis vel, dapibus at, diam.",
            id: "0cf9212e-887c-445c-aeb8-a5aa38736a6e",
            page_number: 110,
          },
          {
            note_type: "connection",
            highlight:
              "Quisque porta volutpat erat. Quisque erat eros, viverra eget, congue eget, semper rutrum, nulla. Nunc purus.",
            content:
              "Praesent blandit. Nam nulla. Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede. Morbi porttitor lorem id ligula.",
            id: "bb1d992e-adbf-4f05-abc1-edc2697d266d",
            page_number: 81,
          },
        ],
      },
    ],
  },
  {
    isbn: "678263058-3",
    title:
      "Nobody Will Speak of Us When We're Dead (Nadie hablará de nosotras cuando hayamos muerto)",
    authors: [
      "Valentina de Cullip",
      "Hamilton Farres",
      "Lauren Essam",
      "Garvin Sainthill",
    ],
    cover_image_url: "http://dummyimage.com/186x100.png/dddddd/000000",
    is_fiction: true,
    tags: ["Horror|Thriller", "Comedy|Drama|Romance"],
    summary: "Quisque porta volutpat erat.",
    pinned: false,
    active: true,
    chapters: [
      {
        id: "3e474bb7-be53-451c-9585-1b2045f63b02",
        title: "Leopard, indian",
        chapter_number: 1,
        sort_order: 1,
        summary:
          "Aenean fermentum. Donec ut mauris eget massa tempor convallis.",
        notes: [
          {
            note_type: "connection",
            highlight:
              "Aliquam quis turpis eget elit sodales scelerisque. Mauris sit amet eros.",
            content:
              "Donec vitae nisi. Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla. Sed vel enim sit amet nunc viverra dapibus. Nulla suscipit ligula in lacus. Curabitur at ipsum ac tellus semper interdum.",
            id: "fce8d47d-20c2-4884-a3eb-02ef1878102a",
            page_number: 179,
          },
          {
            note_type: "connection",
            highlight: "Nulla mollis molestie lorem.",
            content:
              "Sed vel enim sit amet nunc viverra dapibus. Nulla suscipit ligula in lacus. Curabitur at ipsum ac tellus semper interdum.",
            id: "04741fc0-cf28-41bd-8e95-de7cfb0a6073",
            page_number: 334,
          },
          {
            note_type: "connection",
            highlight:
              "Donec ut mauris eget massa tempor convallis. Nulla neque libero, convallis eget, eleifend luctus, ultricies eu, nibh.",
            content: "In congue. Etiam justo. Etiam pretium iaculis justo.",
            id: "4f67bad7-0a41-4740-863f-3bc8e1adf740",
            page_number: 224,
          },
          {
            note_type: "thought",
            highlight: "Aenean lectus. Pellentesque eget nunc.",
            content:
              "Aenean sit amet justo. Morbi ut odio. Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo.",
            id: "ad169ea6-41ca-4c47-a38d-babe0e8ed090",
            page_number: 179,
          },
          {
            note_type: "definition",
            highlight: "Donec semper sapien a libero. Nam dui.",
            content:
              "Nulla ut erat id mauris vulputate elementum. Nullam varius. Nulla facilisi.",
            id: "346200aa-e622-40c2-a415-f64f64527adb",
            page_number: 34,
          },
        ],
      },
      {
        id: "cde140fc-0f78-4a51-aa1d-0714f9bfebe0",
        title: "White-lipped peccary",
        chapter_number: 2,
        sort_order: 2,
        summary: "Proin at turpis a pede posuere nonummy.",
        notes: [
          {
            note_type: "definition",
            highlight: "Aliquam quis turpis eget elit sodales scelerisque.",
            content:
              "Aenean auctor gravida sem. Praesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio. Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo.",
            id: "e7219ad5-3cb4-4381-9ac1-304e351fd249",
            page_number: 124,
          },
          {
            note_type: "connection",
            highlight: "Quisque ut erat.",
            content:
              "Praesent lectus. Vestibulum quam sapien, varius ut, blandit non, interdum in, ante. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis faucibus accumsan odio. Curabitur convallis. Duis consequat dui nec nisi volutpat eleifend.",
            id: "66ed6140-102e-4590-92c1-5cbc1c8db6d5",
            page_number: 191,
          },
        ],
      },
      {
        id: "fc6db7de-3993-4691-a502-a6a53c331eec",
        title: "Old world fruit bat (unidentified)",
        chapter_number: 3,
        sort_order: 3,
        summary: "In blandit ultrices enim.",
        notes: [
          {
            note_type: "quote",
            highlight:
              "Suspendisse potenti. In eleifend quam a odio. In hac habitasse platea dictumst.",
            content:
              "Morbi ut odio. Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo. In blandit ultrices enim. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin interdum mauris non ligula pellentesque ultrices.",
            id: "57ff8d43-a463-40a4-bb98-5e843feb97ac",
            page_number: 192,
          },
          {
            note_type: "thought",
            highlight: "Donec semper sapien a libero.",
            content:
              "Fusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl. Nunc rhoncus dui vel sem.",
            id: "4525fcd2-8679-450b-b596-be8887241a74",
            page_number: 110,
          },
          {
            note_type: "definition",
            highlight:
              "Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis. Fusce posuere felis sed lacus.",
            content:
              "Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl. Nunc rhoncus dui vel sem. Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus.",
            id: "72889a01-794a-470e-9271-a1aec51dced6",
            page_number: 8,
          },
          {
            note_type: "quote",
            highlight:
              "Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem.",
            content:
              "Pellentesque eget nunc. Donec quis orci eget orci vehicula condimentum. Curabitur in libero ut massa volutpat convallis.",
            id: "cb0c9c1b-b564-4a08-ad13-c33384c2638a",
            page_number: 160,
          },
          {
            note_type: "connection",
            highlight: "In congue. Etiam justo.",
            content:
              "Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.",
            id: "4caa618e-3a70-43db-b15c-c10a085f922d",
            page_number: 192,
          },
        ],
      },
      {
        id: "2b19e065-52be-41c8-963d-1837040ed34d",
        title: "Azara's zorro",
        chapter_number: 4,
        sort_order: 4,
        summary:
          "Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam vel augue.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "In hac habitasse platea dictumst. Maecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem.",
            content:
              "Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus.",
            id: "4d8be36d-93dd-4dc8-9ece-b91c3c1ba7ba",
            page_number: 307,
          },
          {
            note_type: "concept",
            highlight:
              "In hac habitasse platea dictumst. Maecenas ut massa quis augue luctus tincidunt.",
            content:
              "In congue. Etiam justo. Etiam pretium iaculis justo. In hac habitasse platea dictumst. Etiam faucibus cursus urna.",
            id: "fbb886ed-9f53-4926-ad24-426dab90d7a1",
            page_number: 386,
          },
          {
            note_type: "connection",
            highlight:
              "Donec quis orci eget orci vehicula condimentum. Curabitur in libero ut massa volutpat convallis.",
            content:
              "Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros. Vestibulum ac est lacinia nisi venenatis tristique. Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat. In congue.",
            id: "daa1a424-c3c4-4aa3-8390-02a090981d83",
            page_number: 98,
          },
          {
            note_type: "connection",
            highlight:
              "Proin interdum mauris non ligula pellentesque ultrices. Phasellus id sapien in sapien iaculis congue.",
            content:
              "Duis at velit eu est congue elementum. In hac habitasse platea dictumst. Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante.",
            id: "771163cf-97af-4d4f-a1bf-4139ff0ad625",
            page_number: 360,
          },
        ],
      },
      {
        id: "2bf00caf-b88d-41f2-b0d7-f66ef5f14b29",
        title: "Common wallaroo",
        chapter_number: 5,
        sort_order: 5,
        summary:
          "Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo.",
        notes: [
          {
            note_type: "connection",
            highlight:
              "Proin risus. Praesent lectus. Vestibulum quam sapien, varius ut, blandit non, interdum in, ante.",
            content:
              "Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros. Vestibulum ac est lacinia nisi venenatis tristique. Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat. In congue.",
            id: "03d8fecf-56ce-4eb6-81bf-e705d22c3375",
            page_number: 166,
          },
          {
            note_type: "thought",
            highlight: "Maecenas pulvinar lobortis est.",
            content:
              "Phasellus id sapien in sapien iaculis congue. Vivamus metus arcu, adipiscing molestie, hendrerit at, vulputate vitae, nisl. Aenean lectus.",
            id: "56a42d8d-7105-4cd9-987c-1c0d7a774e86",
            page_number: 89,
          },
        ],
      },
    ],
  },
  {
    isbn: "263210481-5",
    title: "Stranger, The (Agantuk) (Visitor, The)",
    authors: ["Horton Barratt", "Niki Pugsley", "Deni Treadgear"],
    cover_image_url: "http://dummyimage.com/154x100.png/cc0000/ffffff",
    is_fiction: false,
    tags: ["Drama|Romance"],
    summary:
      "Aliquam sit amet diam in magna bibendum imperdiet. Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis.",
    pinned: true,
    active: false,
    chapters: [
      {
        id: "82084728-d81b-475f-a09d-90130646189e",
        title: "Dassie",
        chapter_number: 1,
        sort_order: 1,
        summary: "Nulla tellus. In sagittis dui vel nisl.",
        notes: [
          {
            note_type: "thought",
            highlight:
              "Morbi odio odio, elementum eu, interdum eu, tincidunt in, leo.",
            content: "In congue. Etiam justo. Etiam pretium iaculis justo.",
            id: "caf46bbf-f1f7-4d8a-808b-5acb5b518024",
            page_number: 318,
          },
          {
            note_type: "quote",
            highlight: "Morbi a ipsum.",
            content:
              "In eleifend quam a odio. In hac habitasse platea dictumst. Maecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat.",
            id: "20d82cb6-7d05-442a-8b68-108e369278cf",
            page_number: 163,
          },
          {
            note_type: "concept",
            highlight:
              "Cras non velit nec nisi vulputate nonummy. Maecenas tincidunt lacus at velit.",
            content:
              "Aliquam non mauris. Morbi non lectus. Aliquam sit amet diam in magna bibendum imperdiet. Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis.",
            id: "37134256-d5c1-48ee-b4e4-fd2f159e385f",
            page_number: 276,
          },
          {
            note_type: "thought",
            highlight:
              "Cras in purus eu magna vulputate luctus. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien.",
            content:
              "Sed accumsan felis. Ut at dolor quis odio consequat varius. Integer ac leo. Pellentesque ultrices mattis odio.",
            id: "0efa3ade-a4fe-418e-88b4-3b2a25380ee2",
            page_number: 309,
          },
        ],
      },
      {
        id: "28cf5ebe-461e-40f9-855e-9014928e834b",
        title: "Cat, long-tailed spotted",
        chapter_number: 2,
        sort_order: 2,
        summary: "Nunc rhoncus dui vel sem. Sed sagittis.",
        notes: [
          {
            note_type: "definition",
            highlight:
              "Morbi quis tortor id nulla ultrices aliquet. Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo. Pellentesque viverra pede ac diam.",
            content:
              "Cras in purus eu magna vulputate luctus. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam vel augue.",
            id: "eef03d30-a07b-423a-b6f6-591ebc978ace",
            page_number: 178,
          },
          {
            note_type: "definition",
            highlight: "Vivamus tortor. Duis mattis egestas metus.",
            content:
              "Fusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl. Nunc rhoncus dui vel sem. Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci.",
            id: "ba152382-75e7-4439-95c7-8dc7d733726b",
            page_number: 15,
          },
          {
            note_type: "definition",
            highlight:
              "Donec ut mauris eget massa tempor convallis. Nulla neque libero, convallis eget, eleifend luctus, ultricies eu, nibh. Quisque id justo sit amet sapien dignissim vestibulum.",
            content:
              "Aenean lectus. Pellentesque eget nunc. Donec quis orci eget orci vehicula condimentum. Curabitur in libero ut massa volutpat convallis. Morbi odio odio, elementum eu, interdum eu, tincidunt in, leo.",
            id: "99b8bf23-1e8f-46d8-b166-b402ce27079c",
            page_number: 172,
          },
        ],
      },
      {
        id: "8a6dd5c3-2435-4e0c-8ccb-b203faf70246",
        title: "Eagle, white-bellied sea",
        chapter_number: 3,
        sort_order: 3,
        summary:
          "Morbi quis tortor id nulla ultrices aliquet. Maecenas leo odio, condimentum id, luctus nec, molestie sed, justo.",
        notes: [
          {
            note_type: "thought",
            highlight: "Donec posuere metus vitae ipsum. Aliquam non mauris.",
            content:
              "Mauris sit amet eros. Suspendisse accumsan tortor quis turpis. Sed ante.",
            id: "796916b7-7399-4b8a-bdce-301161e6208b",
            page_number: 300,
          },
          {
            note_type: "connection",
            highlight:
              "Duis ac nibh. Fusce lacus purus, aliquet at, feugiat non, pretium quis, lectus.",
            content:
              "Vivamus in felis eu sapien cursus vestibulum. Proin eu mi. Nulla ac enim.",
            id: "8c2b269b-49d1-4b84-9f4e-c131c320e8c4",
            page_number: 254,
          },
          {
            note_type: "connection",
            highlight: "Phasellus sit amet erat.",
            content:
              "Nullam sit amet turpis elementum ligula vehicula consequat. Morbi a ipsum. Integer a nibh. In quis justo.",
            id: "90c3a4cc-65e7-4da8-bcb1-5f5de45457df",
            page_number: 364,
          },
        ],
      },
      {
        id: "2b2e85e4-6814-49be-b53e-7d4c224da8db",
        title: "Common zebra",
        chapter_number: 4,
        sort_order: 4,
        summary:
          "Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante.",
        notes: [
          {
            note_type: "definition",
            highlight:
              "Nullam sit amet turpis elementum ligula vehicula consequat. Morbi a ipsum. Integer a nibh.",
            content:
              "Duis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa. Donec dapibus. Duis at velit eu est congue elementum. In hac habitasse platea dictumst. Morbi vestibulum, velit id pretium iaculis, diam erat fermentum justo, nec condimentum neque sapien placerat ante.",
            id: "61f0f870-743f-4ab3-a8f3-cd27161f2056",
            page_number: 60,
          },
          {
            note_type: "quote",
            highlight:
              "Nam nulla. Integer pede justo, lacinia eget, tincidunt eget, tempus vel, pede.",
            content:
              "Nulla nisl. Nunc nisl. Duis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa. Donec dapibus. Duis at velit eu est congue elementum.",
            id: "a87eb380-9ff5-4ade-b4d9-46b161ec0c0b",
            page_number: 98,
          },
        ],
      },
    ],
  },
];
